import { render, staticRenderFns } from "./upload-images.vue?vue&type=template&id=f6b46514"
import script from "./upload-images.vue?vue&type=script&lang=js"
export * from "./upload-images.vue?vue&type=script&lang=js"
import style0 from "./upload-images.vue?vue&type=style&index=0&id=f6b46514&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports